module.exports = __webpack_public_path__ + "src/assets/img/check.5c7a0c78.svg";